<script lang="ts">
  import useSWR from "$lib/swr";
  import Loading from "$lib/ui/system/Loading.svelte";
  import Popup from "$lib/ui/system/Popup.svelte";
  import WorkspaceMetrics from "./WorkspaceMetrics.svelte";
  import type { WorkspaceActiveResources } from "~proto/modal_server/proto/public_api";

  export let workspace: string;
  export let open: boolean;

  const { data: resources, update: updateUrl2 } =
    useSWR<WorkspaceActiveResources>(undefined, { refreshInterval: 10000 });
  $: updateUrl2(`/api/workspaces/${workspace}/active-resources`);
</script>

<Popup title="Active Resources" size="lg" showCloseButton {open} on:close>
  {#if $resources}
    <WorkspaceMetrics {workspace} resources={$resources} />
  {:else}
    <Loading />
  {/if}
</Popup>
